import { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

import { useKinsideAuth } from '../../hooks/useKinsideAuth';
import { useDependencies } from '../../dependencies';
import { Button } from './Button';

const KINSIDE_LOGO_URL = 'https://assets.urbansitter.com/static/img/logos/kinside.svg';

const KinsideButton = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    services: { config },
    stores: { user, verification },
  } = useDependencies();
  const { token, refreshToken, userInfoRef, searchInfoRef, setTokenValues } = useKinsideAuth();

  const handleKinsideClick =
    async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();

    if (!verification.isFailed()) {
      try {
        await user.refreshAuthToken();
        setTokenValues();
        const target  = event.target as HTMLFormElement;
        target.submit();
      } catch {
        user.logout();
      }
    } else {
      toast.error(t('identityCheck.stripeVerification.verificationFailed.header'));
    }
  };

  return (
    <form id='kindside-form' onSubmit={handleKinsideClick} action={config.KINSIDE_URL} method='post' target='_blank'>
      <Button
        id='kinside'
        name={t('components.buttons.kinside')}
        className='border lg:border-2 border-kinsideGreen flex group h-9 xl:h-10 items-center justify-center rounded-full w-24 md:w-28 lg:w-36 hover:bg-kinsideGreen'
        type='submit'
        value='submit'
      >
        <img
          src={KINSIDE_LOGO_URL}
          alt={t('components.buttons.kinside')}
          className='h-4 lg:h-4 m-0 group-hover:brightness-0 group-hover:invert'
        />
      </Button>
      <input id='token' name='token' value={ token } type='hidden' />
      <input id='refreshToken' name='refreshToken' value={ refreshToken } type='hidden' />
      <input ref={userInfoRef} id='userInfo' name='user_info' type='hidden' />
      <input ref={searchInfoRef} id='searchInfo' name='search_info' type='hidden' />
    </form>
  );
};

export { KinsideButton };
